import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getAxiosInstance } from "../../../api";

const initialState = {
  currentPage: 1,
  currentPageSize: 10,
  currentFilter: "all",
  sortBy: "",
  sortOrder: "desc",
  search: "",
  isEdit: false,
  showCreateModal: false,
  showEditNumberTypeModal: false,
  showDeleteModal: false,
  clearSelection: false,
  shoeEditModal: false,
  selectedId: "",
  isLoading: false,
  showPassword: false,
  editPrivacyPolicyData: {},
  editHomePageData: {},
  componentIndex: "",
  contentId: "",
  characters: [],
  selectedComponent: "",
  selectedComponentIndex: "",
};

export const getPrivacyPolicyEditData = createAsyncThunk(
  "/privacy/edit",
  async (id, { rejectWithValue }) => {
    const api = await getAxiosInstance();
    try {
      const response = await api.get(
        `/admin/settings/app/edit?_id=${id}`
      );
      return response.data
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

const privacySlice = createSlice({
  name: "privacy",
  initialState,
  reducers: {
    updateConfig: (state, action) => {
      action.payload(state);
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getPrivacyPolicyEditData.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(getPrivacyPolicyEditData.fulfilled, (state, action) => {
        state.editPrivacyPolicyData = action.payload?.data;
      })
      .addCase(getPrivacyPolicyEditData.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      });
  },
});

export const { updateConfig } = privacySlice.actions;
export default privacySlice.reducer;
